<template>
  <div class="footerBox" ref="footMenu" v-show="isOriginHeight">
    <div class="footItem" @click="tabHandle('index')">
      <img
        src="../../static/images/tabBar/icon01.png"
        v-show="active != 'index'"
        class="homeIcon"
        alt=""
      />
      <img
        src="../../static/images/tabBar/icon01_on.png"
        v-show="active == 'index'"
        class="homeIcon"
        alt=""
      />
      <div class="footText" :class="active == 'index' ? 'active' : ''">
        首页
      </div>
    </div>
    <div class="footItem" @click="tabHandle('topicsDiscover')">
      <img
        src="../../static/images/tabBar/icon02.png"
        v-show="active != 'topicsDiscover'"
        class="homeIcon"
        alt=""
      />
      <img
        src="../../static/images/tabBar/icon02_on.png"
        v-show="active == 'topicsDiscover'"
        class="homeIcon"
        alt=""
      />
      <div class="footText" :class="active == 'topicsDiscover' ? 'active' : ''">
        发现
      </div>
    </div>
    <div class="publishItem">
      <img
        src="../../static/images/tabBar/add_on.png"
        v-show="active != 'publish'"
        class="homeIcon"
        alt=""
        @click="postClick"
      />
      <img
        src="../../static/images/tabBar/add_on.png"
        v-show="active == 'publish'"
        class="homeIcon"
        alt=""
        @click="postClick"
      />
      <div class="choice-box" v-if="publishBtn">
        <div class="choiceItem" @click="tabHandle('publishVideo')">
          <div class="iconfont icon-shipin" style="color: #fd5f11"></div>
          <div style="color: #333">发视频</div>
        </div>
        <div class="choiceItem" @click="tabHandle('publishPic')">
          <div class="iconfont icon-tuwen" style="color: #1987e4"></div>
          <div style="color: #333">发图文</div>
        </div>
        <div class="choiceItem" @click="tabHandle('publishTopic')">
          <div class="iconfont icon-huati1" style="color: #13b42a"></div>
          <div style="color: #333">创话题</div>
        </div>
      </div>
    </div>
    <div class="footItem" @click="tabHandle('message')">
      <img
        src="../../static/images/tabBar/icon03.png"
        v-show="active != 'message'"
        class="homeIcon"
        alt=""
      />
      <img
        src="../../static/images/tabBar/icon03_on.png"
        v-show="active == 'message'"
        class="homeIcon"
        alt=""
      />
      <div class="red-dot" v-if="hasMsg || hasRmsg"></div>
      <div class="footText" :class="active == 'message' ? 'active' : ''">
        消息
      </div>
    </div>
    <div class="footItem" @click="tabHandle('member')">
      <img
        src="../../static/images/tabBar/icon04.png"
        v-show="active != 'member'"
        class="homeIcon"
        alt=""
      />
      <img
        src="../../static/images/tabBar/icon04_on.png"
        v-show="active == 'member'"
        class="homeIcon"
        alt=""
      />
      <div class="footText" :class="active == 'member' ? 'active' : ''">
        我的
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { checkMessage } from "@/api/index";
export default {
  name: "FooterTab",
  data() {
    return {
      type: 1,
      hasRmsg: false,
      hasMsg: false,
      publishBtn: false,
      footClass: "showClass",
      isOriginHeight: true,
      oHeight: 0,
      screenHeight: document.documentElement.clientHeight,
      originHeight: document.documentElement.clientHeight,
    };
  },
  watch: {
    screenHeight(val) {
      if (this.originHeight > val + 100) {
        //加100为了兼容华为的返回键
        this.isOriginHeight = false;
      } else {
        this.isOriginHeight = true;
      }
    },
  },

  computed: {
    ...mapState({
      active: function (state) {
        return this.$store.state.footerActive;
      },
      conversationList: (state) => state.conversation.conversationList,
    }),
  },

  methods: {
    //tab切换
    tabHandle: function (type) {
      var that = this;
      if (type == "home") {
        that.$router.push({ path: "/" });
      } else if (type == "topicsDiscover") {
        that.$router.push({ path: "/topicsDiscover" });
      } else if (type == "publishVideo") {
        that.$router.push({ path: "/publishVideo" });
      } else if (type == "publishPic") {
        that.$router.push({ path: "/publishPic" });
      } else if (type == "publishTopic") {
        that.$router.push({ path: "/publishTopic" });
      } else if (type == "message") {
        that.$router.push({ path: "/message" });
      } else if (type == "member") {
        that.$router.push({ path: "/member" });
      } else {
        that.$router.push({ path: "/" });
      }
    },

    //发布按钮点击
    postClick: function () {
      this.publishBtn = !this.publishBtn;
    },

    //检测消息接收
    getCheckMessage() {
      checkMessage().then((res) => {
        this.hasMsg = res.Data.HasMessage;
      });
    },

    //检测消息显示
    checkChat() {
      var unreadCount = this.conversationList.findIndex(
        (value) => value.unreadCount > 0
      );
      if (unreadCount == -1) {
        this.hasRmsg = false;
      } else {
        this.hasRmsg = true;
      }
    },
  },

  mounted() {
    if (localStorage.getItem("token")) {
      this.getCheckMessage();
      this.checkChat();
    }
  },

  updated() {
    this.checkChat();
  },
};
</script>
<style scoped>
.footerBox {
  display: flex;
  flex-direction: row;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background-color: #fff;
  z-index: 1000;
  border-top: 1px solid #eee;
  color: #666666;
  padding-bottom: 20px;
}

.footItem {
  flex: 1;
  padding-top: 6px;
  box-sizing: border-box;
  text-align: center;
  position: relative;
}

.homeIcon {
  display: block;
  width: 22px;
  height: 22px;
  margin: 0 auto 4px;
}

.footText {
  font-size: 11px;
  color: #333333;
}

.publishItem {
  flex: 1;
  box-sizing: border-box;
  text-align: center;
  position: relative;
}

.publishItem .homeIcon {
  position: absolute;
  width: 60px;
  height: 60px;
  top: -15px;
  left: 50%;
  transform: translate(-50%, 0);
}
.active {
  color: #eb4e4e;
}
.displayClass {
  position: static;
  display: block;
}
.showClass {
  position: fixed;
  display: block;
}

.choice-box {
  position: absolute;
  width: 120px;
  top: 0;
  left: 50%;
  background-color: #ffffff;
  transform: translate(-50%, -105%);
  box-shadow: 0px 0px 7px 0px rgba(214, 47, 47, 0.5);
  border-radius: 5px;
}
.choiceItem {
  display: flex;
  align-items: center;
  justify-content: center;
}

.choice-box div {
  height: 50px;
  line-height: 50px;
  color: #333333;
  font-size: 14px;
  border-top: 1px solid #eee;
}

.choice-box div .iconfont {
  font-size: 19px !important;
  margin-right: 6px;
}

.choice-box div:first-child {
  border-top: none;
}

.red-dot {
  position: absolute;
  top: 5px;
  right: 30%;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #d62f2f;
}
</style>
